import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, coerceBoolean } from '@tyler-components-web/core';
import { DialogFoundation } from './dialog-foundation';
import { DialogAdapter } from './dialog-adapter';
import { DIALOG_CONSTANTS } from './dialog-constants';
import { BackdropComponent } from '../backdrop';
var template = require('./dialog.html');
var styles = require('./dialog.css');
var DialogComponent = /** @class */ (function (_super) {
    __extends(DialogComponent, _super);
    function DialogComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, DIALOG_CONSTANTS.elementName, template, styles);
        _this._foundation = new DialogFoundation(new DialogAdapter(_this));
        return _this;
    }
    Object.defineProperty(DialogComponent, "observedAttributes", {
        get: function () {
            return [
                DIALOG_CONSTANTS.attributes.BACKDROP_CLOSE,
                DIALOG_CONSTANTS.attributes.ESCAPE_CLOSE,
                DIALOG_CONSTANTS.attributes.OPEN,
                DIALOG_CONSTANTS.attributes.FULLSCREEN,
                DIALOG_CONSTANTS.attributes.POSITION_TYPE,
                DIALOG_CONSTANTS.attributes.POSITION_X,
                DIALOG_CONSTANTS.attributes.POSITION_Y,
                DIALOG_CONSTANTS.attributes.MOVEABLE,
                DIALOG_CONSTANTS.attributes.MOVE_TARGET
            ];
        },
        enumerable: true,
        configurable: true
    });
    DialogComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'backdropClose');
        upgradeProperty(this, 'escapeClose');
        upgradeProperty(this, 'open');
        upgradeProperty(this, 'fullscreen');
        upgradeProperty(this, 'positionType');
        upgradeProperty(this, 'positionX');
        upgradeProperty(this, 'positionY');
        upgradeProperty(this, 'moveable');
        upgradeProperty(this, 'moveTarget');
    };
    DialogComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    DialogComponent.prototype.disconnectedCallback = function () {
        this._foundation.destroy();
    };
    DialogComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case DIALOG_CONSTANTS.attributes.BACKDROP_CLOSE:
                this.backdropClose = newValue === 'true';
                break;
            case DIALOG_CONSTANTS.attributes.ESCAPE_CLOSE:
                this.escapeClose = newValue === 'true';
                break;
            case DIALOG_CONSTANTS.attributes.OPEN:
                this.open = coerceBoolean(newValue);
                break;
            case DIALOG_CONSTANTS.attributes.FULLSCREEN:
                this.fullscreen = this.hasAttribute(DIALOG_CONSTANTS.attributes.FULLSCREEN);
                break;
            case DIALOG_CONSTANTS.attributes.POSITION_TYPE:
                this.positionType = newValue;
                break;
            case DIALOG_CONSTANTS.attributes.POSITION_X:
                this.positionX = newValue;
                break;
            case DIALOG_CONSTANTS.attributes.POSITION_Y:
                this.positionY = newValue;
                break;
            case DIALOG_CONSTANTS.attributes.MOVEABLE:
                this.moveable = this.hasAttribute(DIALOG_CONSTANTS.attributes.MOVEABLE);
                break;
            case DIALOG_CONSTANTS.attributes.MOVE_TARGET:
                this.moveTarget = newValue;
                break;
        }
    };
    Object.defineProperty(DialogComponent.prototype, "backdropClose", {
        get: function () {
            return this._foundation.backdropClose;
        },
        /** Controls whether clicking the backdrop closes the dialog or not. Default is true. */
        set: function (value) {
            this._foundation.backdropClose = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "escapeClose", {
        get: function () {
            return this._foundation.escapeClose;
        },
        /** Controls whether pressing the escape key closes the dialog or not. Default is true. */
        set: function (value) {
            this._foundation.escapeClose = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "open", {
        /** Controls whether the dialog is open or not. Default is false. */
        get: function () {
            return this._foundation.open;
        },
        set: function (value) {
            this._foundation.open = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "fullscreen", {
        get: function () {
            return this._foundation.fullscreen;
        },
        /** Controls whether the dialog is full screen or not. Default is false. */
        set: function (value) {
            this._foundation.fullscreen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "openCallback", {
        /** The function to call when the dialog wants to open. */
        set: function (callback) {
            this._foundation.openCallback = callback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "closeCallback", {
        /** the function to call when the dialog wants to close. */
        set: function (callback) {
            this._foundation.closeCallback = callback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "beforeCloseCallback", {
        /** the function to call when the dialog wants to close. */
        set: function (callback) {
            this._foundation.beforeCloseCallback = callback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "positionType", {
        /** Gets/sets the position type when using custom positioning values. Default is 'absolute'. */
        get: function () {
            return this._foundation.positionType;
        },
        set: function (value) {
            this._foundation.positionType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "positionX", {
        /** Controls the horizontal position of the dialog surface. */
        get: function () {
            return this._foundation.positionX;
        },
        set: function (value) {
            this._foundation.positionX = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "positionY", {
        /** Controls the vertical position of the dialog surface. */
        get: function () {
            return this._foundation.positionY;
        },
        set: function (value) {
            this._foundation.positionY = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "moveable", {
        /** Gets/sets whether the dialog surface can be moved or not. */
        get: function () {
            return this._foundation.moveable;
        },
        set: function (value) {
            this._foundation.moveable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogComponent.prototype, "moveTarget", {
        /** Gets/sets the selector used to target the element that is used as the drag target. */
        get: function () {
            return this._foundation.moveTarget;
        },
        set: function (value) {
            this._foundation.moveTarget = value;
        },
        enumerable: true,
        configurable: true
    });
    DialogComponent.prototype.initializeMoveTarget = function () {
        this._foundation.initializeMoveTarget();
    };
    DialogComponent.prototype.resetPosition = function () {
        this._foundation.resetPosition();
    };
    DialogComponent = __decorate([
        CustomElement({
            name: DIALOG_CONSTANTS.elementName,
            dependencies: [BackdropComponent]
        })
    ], DialogComponent);
    return DialogComponent;
}(HTMLElement));
export { DialogComponent };
